<template>
  <router-link class="tile-preview__wrapper" :to="tile.to">
    <v-responsive
      class="tile-preview"
      :class="`tile-preview--${tile.color}`"
      :aspect-ratio="720 / 400"
    >
      <div :class="`tile-preview__bg`"></div>
      <div class="tile-preview__container">
        <!-- <div class="tile-preview__subtitle">{{ tile.subtitle }}</div> -->
        <div class="tile-preview__title">{{ tile.title }}</div>
        <div class="tile-preview__description">{{ tile.description }}</div>
      </div>
    </v-responsive>
  </router-link>
</template>

<script>
export default {
  props: {
    tile: Object,
  },
};
</script>

<style scope lang="scss">
.tile-preview {
  width: 100%;
  background: red;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  position: relative;
  min-height: 100%;

  &:hover {
    filter: brightness(105%);
  }

  &--blue {
    .tile-preview__bg {
      background: linear-gradient(
        32.58deg,
        rgba(0, 125, 186, 0.8) 0.93%,
        rgba(0, 41, 120, 0.8) 100%
      );
    }

    .tile-preview__subtitle {
      color: #f2a900;
    }
  }
  &--yellow {
    .tile-preview__bg {
      background: linear-gradient(
        58.83deg,
        rgba(242, 169, 0, 0.8) 0%,
        rgba(181, 133, 0, 0.8) 100%
      );
    }
    .tile-preview__subtitle {
      color: #012169;
    }
  }

  .v-responsive__content {
    flex: auto;
  }

  &__bg {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }

  &__subtitle {
    font-family: $body-font-family, sans-serif;
    font-weight: 600;
    font-size: 1.5em;
    line-height: 1.2em;
    text-align: center;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    margin-bottom: 20px;
  }

  &__title {
    font-family: $body-font-family, sans-serif;
    font-weight: 600;
    font-size: 4em;
    line-height: 1em;
    text-align: center;
    color: #ffffff;
    margin-bottom: 20px;
  }

  &__description {
    font-family: $body-font-family, sans-serif;
    font-weight: 600;
    font-size: 1.125em;
    line-height: 1.5em;
    text-align: center;
    color: #ffffff;
    white-space: pre-line;
  }
  &__container {
    position: relative;
    z-index: 1;
    padding: 0 100px;
  }
  &__wrapper {
    display: block;
    text-decoration: none;
    border-radius: 10px;
    overflow: hidden;
    margin: 10px;
  }
}

@media screen and (max-width: 1264px) {
  .tile-preview {
    &__title {
      font-size: 2.5em;
    }

    &__description {
      font-size: 1em;
      font-weight: normal;
    }

    &__container {
      padding: 40px;
    }
  }
}

@media screen and (max-width: 960px) {
  .tile-preview {
    min-height: 175px;

    .v-responsive__sizer {
      display: none !important;
    }

    .v-responsive__content {
      margin: 0 !important;
    }

    &__title {
      font-size: 2.2em;
    }

    &__subtitle {
      font-size: 1em;
      margin-bottom: 5px;
    }

    &__container {
      padding: 20px;
    }
    &__wrapper {
      width: 100% !important;
    }
  }
}
</style>
